<template>
  <div class="blog">
    <div class="blog-body" ref="blogBody">
      <h1 class="blog-body__title">{{ fields.title }}</h1>
      <div class="blog-body-img">
        <img v-if="fields.logo" :src="fields.logo.url" alt="">
      </div>
      <div class="blog-body__text" v-for="(paragraph, index) in fields.richContent" :key="index">
        <p v-if="paragraph.spans.length === 0 || paragraph.spans[0].type !== 'em'" v-html="treatHyperlinkOrBold(paragraph)"></p>
        <p class="blog-body__text-quote" v-if="paragraph.spans.length !== 0 && paragraph.spans[0].type == 'em'">{{ paragraph.text }}</p>
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import LogoImg from '@/assets/logo.png';
import mixpanel from "mixpanel-browser";

export default {
  name: 'Blog-post',
  data: () => ({
    LogoImg,
    htmlToInsert: '',
    fields: {
      title: null,
      logo: null,
      richContent: null
    }
  }),
  metaInfo () {
    return {
      title: this.fields.title,
    }
  },
  components: {
  },
  methods: {
    getContent(uid) {
      this.$prismic.client.getByUID('blog_page', uid)
      .then((document) => {
        this.fields.title = document.data.blog_title[0].text;
        this.fields.logo = document.data.blog_image;
        this.fields.richContent = document.data.blog_text;
      })
    },
    formatText(textArray) {
      textArray.forEach(line => {
        if(line.spans.length) {
          this.htmlToInsert = this.htmlToInsert + '<p class="blog-body__text-quote">' + line.text + '</p>';
          return;
        }
        this.htmlToInsert =  this.htmlToInsert + '<p>'  + line.text + '</p>'
      });
      this.$forceUpdate();
    },
    handleScroll() {
      mixpanel.track("Opened this article", {"page": this.fields.title});
      window.removeEventListener('scroll', this.handleScroll);
    },
    treatHyperlinkOrBold(paragraph) {
      let paragraphSpans = paragraph.spans;

      if (paragraphSpans.length) {
        let completeSentence = '';
        let sentenceLetterCount = 0;
        let text = paragraph.text;
        console.log(typeof text);

        sentenceLetterCount = paragraphSpans[0].start;
        completeSentence += text.substring(0,sentenceLetterCount);

        paragraphSpans.forEach((span) => {
          if (sentenceLetterCount != span.start){
            completeSentence += text.substring(sentenceLetterCount, span.start);
            sentenceLetterCount = span.start;
          }

          if(span.type == 'strong') {
            completeSentence += '<b>' + text.substring(span.start,span.end)+ '</b>';
            sentenceLetterCount = span.end;
          } else if (span.type == 'hyperlink') {
            completeSentence += '<a target="_blank" href="' + span.data.url + '">' + text.substring(span.start,span.end)+ '</a>';
            sentenceLetterCount = span.end;
          }
        })

        if (sentenceLetterCount != text.length) {
          completeSentence += text.substring(sentenceLetterCount, text.length);
        }

        return completeSentence;
      }

      return paragraph.text;
    }
  },
  mounted() {
    this.getContent(this.$route.params.uid)

    window.addEventListener('scroll', this.handleScroll);
  },
  watch:{
    $route (){
      this.getContent(this.$route.params.uid)
    }
  },
  created() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .blog-body {
    padding: 120px 1rem 1rem 1rem;
    max-width: 720px;
    margin: 0 auto;

    &-img {
      display: flex;
      justify-content: center;
      img {
        max-height: 400px;
        max-width: 400px;
        width: 100%;
      }
    }

    h1, h2, h3, h4 {
      text-align: left;
      font-family: $font-secondary;
      margin-bottom: 1rem;
    }

    &__text {
      & p {
        font-family: $font-primary;
        line-height: 1.6;
        margin-top: 2em;
      }

      &-quote  {
        text-align: center;
        font-family: $font-third !important;
        line-height: 1.6;
        margin-top: 2em;
        font-size: 24px;
        max-width: 600px;
        margin: 0 auto;
      }
    }
  }

</style>
